<!--Title Section-->
<app-title-jumbo title="Risk Management" comment="Stress your portfolio and define the appropriate level of protection using a CPPI strategy"></app-title-jumbo>

<div class="my-container">

<!--Synthesis Section-->
<section>
  <div class="container">
    <div class="offset-1 col-10">
      <mat-accordion *ngIf="currentCluster">
        <mat-expansion-panel [expanded]="false"
                             (opened)="panelOpenState = true"
                             (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ currentCluster.name }}
            </mat-panel-title>
            <mat-panel-description *ngIf="!panelOpenState">
              {{ currentCluster.investment_zone.name }} - {{ currentCluster.currency.name }} - {{ currentCluster.market_positions.name }}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row">
            <div class="col-12" style="line-height: 30px">
              <span>Investable Portfolio</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <div class="w-100" style="border-top:1px dotted grey"></div>
              <span style="color: grey">Investment zone</span>
              <span class="float-right">{{ currentCluster.investment_zone.name }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <div class="w-100" style="border-top:1px dotted grey"></div>
              <span style="color: grey">Benchmark</span>
              <span class="float-right">{{ currentCluster.benchmark_name }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Currency</span>
              <span class="float-right">{{ currentCluster.currency.name }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Creation date</span>
              <span class="float-right">{{ currentCluster.creation_date | date:'d MMM y' }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Market positions</span>
              <span class="float-right">{{ currentCluster.market_positions.name }}</span>
              <div class="w-100" style="border-bottom:1px dotted grey"></div>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Period</span>
              <span class="float-right">
                {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
              </span>
              <div class="w-100" style="border-bottom:1px dotted grey"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Card deck -->
      <div class="card-deck mt-3">

        <!-- Card Metrics -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/030.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='metrics'? 'rgb(118,168,255)' : 'grey'}"><i class="fab fa-sellsy fa-lg"></i>&nbsp;&nbsp;&nbsp; Analytics</h4>
            <!--Text-->
            <p class="card-text">This section presents a risk (max loss and max drawdown) reporting over various period to help you define...</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='metrics'">Analytics</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Metrics -->

        <!-- Card Insurance -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/031.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='cppi'? 'rgb(118,168,255)' : 'grey'}"><i class="fab fa-buffer fa-lg"></i>&nbsp;&nbsp;&nbsp; Insurance</h4>
            <!--Text-->
            <p class="card-text">CPPI analysis simulates what could have been happened in the past if you had implemented a protection ...</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='cppi'">Backtest</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Insurance -->

        <!-- Card Simulations -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/032.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='simulations'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-random fa-lg"></i>&nbsp;&nbsp;&nbsp; Monte Carlo</h4>
            <!--Text-->
            <p class="card-text">This section helps you to find the perfect level of protection for your portfolio based on Monte Carlo simulations.</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='simulations'">Simulations</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Simulations -->

        <!-- Card Implement -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/033.png"
                 alt="Card image cap">
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='implement'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-arrow-alt-circle-down fa-lg"></i>&nbsp;&nbsp;&nbsp; Implement</h4>
            <!--Text-->
            <p class="card-text">Having defined the characteristics, you may implement the Protected Portfolio and get access to the Analytics.</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='implement'">Implement</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Implement -->

      </div>
      <!-- Card deck -->
    </div>
  </div>
</section>
<!--Synthesis Section-->

<!--Metrics Section-->
<app-risk-management-metrics *ngIf="selectBlock=='metrics'"></app-risk-management-metrics>
<!--Metrics Section-->

<!--Insurance Section-->
<app-risk-management-insurance *ngIf="selectBlock=='cppi'" [isComputing]="isInsuranceComputing"
                               [parameters]="insuranceParameters"></app-risk-management-insurance>
<!--Insurance Section-->

<!--Simulation Section-->
<app-risk-management-simulation *ngIf="selectBlock=='simulations'" [isComputing]="isSimulationComputing"
                                [parameters]="simulationParameters"></app-risk-management-simulation>
<!--Simulation Section-->

<!--Implement Protection Section-->
  <div class="container" *ngIf="selectBlock=='implement'">
    <div class="offset-1 col-10">

      <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-sm-6 text-left">
                    <h5 class=" card-category">Risk Management</h5>
                    <h2 class=" card-title"><i class="fas fa-arrow-alt-circle-down fa-lg"></i>&nbsp;&nbsp;&nbsp; Implement Protection</h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">

                <div class="offset-1 col-10">
                  <p>Implement a CPPI strategy and maintain exposure to the upside potential of the risky asset (Investable Portfolio) while providing a capital guarantee against downside risk.</p>
                </div>
                <div class="row mt-3">
                  <div class="col-6" style="line-height: 30px">
                    <div class="w-100" style="border-top:1px dotted grey"></div>
                    <div>
                      <span style="color: grey">Initial Capital</span>
                      <span class="float-right">
                        {{ parameters.initial_capital | number:'1.1-1' }}
                      </span>
                      <br>
                    </div>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <div class="w-100" style="border-top:1px dotted grey"></div>
                    <div>
                      <span style="color: grey">Aggressiveness</span>
                      <span class="float-right">
                        <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                          <mat-select [(value)]="parameters.aggressiveness" [disabled]="isImplementing">
                            <mat-option value="defensive">Defensive</mat-option>
                            <mat-option value="moderate">Moderate</mat-option>
                            <mat-option value="aggressive">Aggressive</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </span>
                    </div>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span style="color: grey">Risk Free Rate</span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;width:50px;">
                        <input matInput type="number" [(ngModel)]="parameters.risk_free_rate" [step]="0.1" [disabled]="isImplementing">
                      </mat-form-field>
                      %
                    </span>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span style="color: grey">Protection Horizon</span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                        <mat-select [(value)]="parameters.protection_horizon" [disabled]="isImplementing">
                          <mat-option value="three_years">3 Years</mat-option>
                          <mat-option value="one_year">1 Year</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span class="float-left">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                        <mat-select [(value)]="parameters.target_type" [disabled]="isImplementing">
                          <mat-option value="maximum_loss">Max Loss</mat-option>
                          <mat-option value="maximum_drawdown">Max Drawdown</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;width:50px;">
                        <mat-select [(value)]="parameters.protection_level" [disabled]="isImplementing">
                          <mat-option [value]="10">10</mat-option>
                          <mat-option [value]="20">20</mat-option>
                          <mat-option [value]="30">30</mat-option>
                        </mat-select>
                      </mat-form-field>
                      %
                    </span>
                    <br>
                    <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                  </div>
                  <div class="col-6" style="line-height: 30px">
                    <span style="color: grey">Rebalancing Frequency</span>
                    <span class="float-right">
                      <mat-form-field style="margin-top:-20px;margin-bottom:-20px;">
                        <mat-select [(value)]="parameters.rebalancing_frequency" [disabled]="isImplementing">
                          <mat-option value="monthly">Monthly</mat-option>
                          <mat-option value="weekly">Weekly</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <div class="w-100" style="border-bottom:1px dotted grey; margin-top: -2px;"></div>
                  </div>
                </div>

              </div>
              <div class=" card-footer">
                <div class="col-12 text-center">
                  <app-button (click)="onImplement()">Implement Protection</app-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>
    </div>
  </div>
<!--Implement Protection Section-->

</div>
